import PropTypes from "prop-types";

import { allKeys, basicKeys } from "../../lib/audioTools";

function KeySelectorKey({ name, number }) {
	return (
		<option value={number}>
			{name}
		</option>
	);
}

function KeySelector({ onChange, selectedKeyNumber }) {
	const basicKeysList = basicKeys();
	const allKeysList = allKeys();

	return (
		<select
			aria-label="Select musical key"
			onChange={onChange}
			value={selectedKeyNumber}
		>
			<optgroup label="Basic keys">
				{basicKeysList.map((k) => (
					<KeySelectorKey name={k.richName()} number={k.number()} key={k.number()} />
				))}
			</optgroup>
			<optgroup label="All keys">
				{allKeysList.map((k) => (
					<KeySelectorKey name={k.richName()} number={k.number()} key={k.number()} />
				))}
			</optgroup>
		</select>
	);
}

KeySelector.propTypes = {
	onChange: PropTypes.func.isRequired,
	selectedKeyNumber: PropTypes.number.isRequired
};

export default KeySelector;
